import React from 'react';
import { useField } from 'formik';
import { makeStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Typography from '@material-ui/core/Typography';

import { requiredFields } from '../FormPage/FormPage';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    marginTop: 0,
  },
}));

type TextareaFieldProps = {
  label: React.ReactNode,
  name: string,
  required?: boolean,
  maxCharInput: number
}

const TextareaWithCharCount = ({ label, name, required, maxCharInput = 100 }: TextareaFieldProps) => {
  const classes = useStyles();
  const [field, meta] = useField(name);
  const isRequired = required || requiredFields[name];
  const hasError = meta.touched && !!meta.error;

  const [labelWidth, setLabelWidth] = React.useState(0);
  const labelRef = React.useRef(null);

  React.useEffect(() => {
    // @ts-ignore
    setLabelWidth(labelRef.current.offsetWidth);
  }, []);

  return (
    <FormControl className={classes.root} error={hasError} variant="outlined">
      <InputLabel htmlFor={name} ref={labelRef}>
        {label} {!isRequired && <Typography variant="caption">(optional)</Typography>}
      </InputLabel>
      <OutlinedInput
        {...field}
        fullWidth
        id={name}
        labelWidth={labelWidth}
        multiline
        name={name}
        rows={3}
      />
      <FormHelperText component="div">
        <Grid container justify="space-between">
          <Grid item>{hasError && meta.error}</Grid>
          <Grid item>{field.value ? field.value.length: '0'}/{maxCharInput}</Grid>
        </Grid>
      </FormHelperText>
    </FormControl>
  );
}

export default TextareaWithCharCount;
